import React from 'react'
import Router from 'next/router'
import Head from 'next/head'
import moment from 'moment'
import styled from 'styled-components'
import { connect } from 'react-redux'

import Wrapper from '../components/Wrapper'
import { HeaderRendering } from '../components/v2/Header'
import FooterIntercomClickableHome from '../components/shared/FooterStatic/FooterIntercomClickableHome'
import { PageTitle } from '../components/v2/PageTitle'
import Results from '../components/Search/Results'
import Filters from '../components/Search/Filters'
import Breadcrumbs from '../components/v2/Breadcrumbs'
import { Row } from '../components/v2/Grid'
import { FullScreenLoader } from 'components/v2/FullScreenLoader'

import _SYMPTOMS from '../utils/seo/symptoms-online.json'
import _SKILLS from '../utils/seo/skills-online.json'
import { updateFilter, addTo, resetFilters } from '../redux/modules/filters'
import { loadPsychos } from '../redux/modules/psychos'
import { navHeight, getUrlFromReq } from '../utils/helpers'
import _LOCATIONS from '../utils/seo/offline.json'
import all from '../utils/allCss'

import { wrapper } from '../redux/store'

import { withSearchOptimizations } from '../hocs'

class BuscaOffline extends React.Component {
  constructor(props) {
    super(props)
    let LOCATIONS = JSON.parse(_LOCATIONS)
    let SYMPTOMS = JSON.parse(_SYMPTOMS)
    let SKILLS = JSON.parse(_SKILLS)

    const city = LOCATIONS.content.find(city => city.slug === props.query.city)
    const symptom = SYMPTOMS.results.find(s => s.slug === props.query.symptom)
    const skill = SKILLS.results.find(s => s.slug === props.query.symptom)

    let neighborhood = null

    let _404 = false

    let force_404 = false // eslint-disable-line
    if (props.query.neighborhood) {
      neighborhood = city.neighborhoods.find(n => n.slug_neighborhood === props.query.neighborhood)
    }

    if (props.query.city && !city) {
      _404 = true
    }

    if (props.query.skill_link && !skill) {
      force_404 = true // eslint-disable-line
    }

    if (props.query.skill_link && symptom) {
      force_404 = true // eslint-disable-line
    }

    this.state = {
      city: city || { name: '', slug: '', neighborhoods: [], timezone: '' },
      neighborhood: neighborhood || null,
      address: '',
      symptom,
      skill,
      _404,
      force_404,
      params: {
        ...props.query
      },
      isGooglebot: props.isGooglebot,
      loadingToPsychologist: false
    }
  }

  componentDidMount() {
    window.scrollTo(0, 0)
    const { _404, force_404 } = this.state
    if (_404 || force_404) {
      Router.push('/404')
    }
  }

  componentDidUpdate(nextProps) {
    if (
      nextProps.query.city !== this.props.query.city ||
      nextProps.query.neighborhood !== this.props.query.neighborhood ||
      nextProps.query.symptom !== this.props.query.symptom ||
      nextProps.query !== this.props.query
    ) {
      let state
      let LOCATIONS = JSON.parse(_LOCATIONS)
      let SYMPTOMS = JSON.parse(_SYMPTOMS)
      let SKILLS = JSON.parse(_SKILLS)
      const city = LOCATIONS.content.find(city => city.slug === nextProps.query.city)
      let symptom = SYMPTOMS.results.find(symptom => symptom.slug === nextProps.query.symptom)
      let skill = SKILLS.results.find(skill => skill.slug === nextProps.query.symptom)

      if (!nextProps.query.neighborhood) {
        state = {
          ...this.state,
          city,
          address: city.name,
          neighborhood: null,
          params: {
            ...this.state.params,
            lat: city.latitude,
            long: city.longitude,
            address: city.name
          }
        }
      } else if (nextProps.query.neighborhood) {
        const neighborhood = city.neighborhoods.find(
          n => n.slug_neighborhood === nextProps.query.neighborhood
        )

        state = {
          ...this.state,
          neighborhood: neighborhood,
          address: neighborhood.neighborhood,
          params: {
            ...this.state.params,
            lat: neighborhood.latitude,
            long: neighborhood.longitude,
            address: neighborhood.neighborhood
          }
        }
      }

      this.setState({
        ...state,
        symptom: symptom || null,
        skill: skill || null,
        params: {
          ...state.params,
          city,
          symptoms: symptom ? symptom.symptoms.map(s => s.title).join(',') : '',
          skills: skill ? skill.skills.map(s => s).join(',') : ''
        }
      })
    }
  }

  render() {
    const {
      city,
      neighborhood,
      params,
      _404,
      force_404, // eslint-disable-line
      isGooglebot
    } = this.state
    const {
      query,
      next,
      prev,
      isServer,
      seoOffline,
      serverSideSymptoms,
      shouldHideConsultationValue,
      isPresentialConsultationEnabled,
      symptoms,
      skills,
      filters,
      psychologists,
      isLoadingPsychologist,
      isLoadingPsychologists,
      hasMorePsychologistsToLoad,
      shouldSpecifyLocationOnMoreFilters,
      timezone,
      onPaginatePsychologists,
      onNavigateToPsychologist
    } = this.props
    const symptom = this.state.skill
    const skill = this.state.symptom
    const hasNeighborhood = !!city.neighborhoods.find(n => n.state.length === 2)
    const cityState = hasNeighborhood
      ? city.neighborhoods.find(n => n.state.length === 2).state
      : ''

    const getCanonicalUrl = (city, neighborhood) => {
      const canonicalUrl = process.env.VITTUDE_OFFLINE_URL + '/psicologos'

      if (neighborhood?.slug_neighborhood)
        return canonicalUrl + '/' + city.slug + '/' + neighborhood.slug_neighborhood

      if (city.slug) return canonicalUrl + '/' + city.slug

      return canonicalUrl
    }

    const metaTags = {
      title: `Psicólogos em ${
        neighborhood ? neighborhood.neighborhood + ', ' + city.name : city.name + ', ' + cityState
      } | Vittude`,
      description: `Os melhores Psicólogos em ${
        neighborhood ? `${neighborhood.neighborhood}, ` + city.name : city.name + ', ' + cityState
      }. A Vittude conecta você com profissionais recomendados. Confira a experiência, preço, opiniões e avaliações. Agende agora!`,
      canonical: getCanonicalUrl(city, neighborhood)
    }
    const body = {
      h1: `Psicólogos em ${
        neighborhood ? neighborhood.neighborhood + ', ' + city.name : city.name + ', ' + cityState
      }`,
      h2: `Recomendamos esses Psicólogos em ${
        neighborhood ? `${neighborhood.neighborhood}, ` + city.name : city.name + ', ' + cityState
      }:`
    }
    let breadcrumb = []
    breadcrumb.push({
      label: 'Psicólogos',
      link: '/psicologos',
      as: '/psicologos',
      alt: 'Psicólogos'
    })

    if (city) {
      breadcrumb.push({
        label: city.name,
        link: `/psicologos-offline?city=${city.slug}`,
        as: `/psicologos/${city.slug}`,
        alt: `Psicólogos em ${city.name}`
      })
    }

    if (neighborhood) {
      breadcrumb.push({
        label: neighborhood.neighborhood,
        link: `/psicologos-offline?city=${city.slug}&neighborhood=${neighborhood.slug_neighborhood}`,
        as: `/psicologos/${city.slug}/${neighborhood.slug_neighborhood}`,
        alt: `Psicólogos em ${neighborhood.neighborhood}`
      })
    }

    if (symptom) {
      metaTags.title = `Psicólogos para ${symptom.description} em ${
        neighborhood ? neighborhood.neighborhood : city.name
      } - Vittude`
      metaTags.description = `Psicólogos para ${symptom.description} em ${
        neighborhood ? neighborhood.neighborhood : city.name
      }. A Vittude conecta você com profissionais recomendados. Confira a experiência, preço, opiniões e avaliações. Agende agora!`
      body.h1 = `Psicólogos para ${symptom.description} - ${
        neighborhood ? neighborhood.neighborhood : city.name
      }`
      body.h2 = `Recomendamos esses Psicólogos para ${symptom.description} em ${
        neighborhood ? neighborhood.neighborhood : city.name
      }:`
      breadcrumb.push({ label: symptom.description })
    }

    if (skill) {
      metaTags.title = `Psicólogos Especializados em ${skill.description} em ${
        neighborhood ? neighborhood.neighborhood : city.name
      }`
      metaTags.description = `Psicólogos Especializados em ${skill.description} em ${
        neighborhood ? neighborhood.neighborhood : city.name
      }. A Vittude conecta você com profissionais recomendados. Confira a experiência, preço, opiniões e avaliações. Agende agora!`
      body.h1 = `Psicólogos para ${skill.description} - ${
        neighborhood ? neighborhood.neighborhood : city.name
      }`
      body.h2 = `Recomendamos esses Psicólogos em ${
        neighborhood ? neighborhood.neighborhood : city.name
      } especializados em ${skill.description}:`
      breadcrumb.push({ label: skill.description })
    }

    if (_404) {
      metaTags.title = 'Paciente Vittude - Encontre o Psicólogo ideal para você'
      metaTags.description =
        'Encontre um psicólogo que combina com você!! Agende uma consulta com um psicólogo em seu bairro ou escolha um psicólogo online.'
      body.h1 = 'Encontrar meu psicólogo'
      breadcrumb = [{ label: 'Não encontrado' }]
    }

    metaTags.hreflang = this.props.urlPath

    return (
      <Wrapper noIndex={!query} metaTags={metaTags} coupon={query.coupon} cssFile={all}>
        <Head>
          {next && <link rel='next' href={`&page=${next}`} />}
          {prev && <link rel='prev' href={`&page=${prev}`} />}
        </Head>

        <HeaderRendering />
        <Body id='search'>
          {this.state.loadingToPsychologist && <FullScreenLoader />}
          <Breadcrumbs links={breadcrumb} />
          <PageTitle title={body.h1} />
          {query ? (
            <div style={{ background: '#eee' }}>
              <Filters
                query={{
                  ...query,
                  ...params,
                  order: this.props.query.order,
                  consultation: 'presencial',
                  seo: true
                }}
                shouldHideConsultationValue={shouldHideConsultationValue}
                isPresentialConsultationEnabled={isPresentialConsultationEnabled}
                symptoms={symptoms}
                skills={skills}
                filters={filters}
                psychologists={psychologists}
              />
              <Results
                query={query}
                filters={filters}
                psychologists={psychologists?.data || []}
                isLoadingPsychologists={isLoadingPsychologists}
                hasMorePsychologistsToLoad={hasMorePsychologistsToLoad}
                shouldSpecifyLocationOnMoreFilters={shouldSpecifyLocationOnMoreFilters}
                timezone={timezone}
                onPaginatePsychologists={onPaginatePsychologists}
                onNavigateToPsychologist={onNavigateToPsychologist}
              />
            </div>
          ) : (
            <div className='container'>
              <div className='row'>
                <div className='col-12' style={{ paddingTop: 100, paddingBottom: 100 }}>
                  <p style={{ fontSize: '2rem', textAlign: 'center' }}>Carregando...</p>
                </div>
              </div>
            </div>
          )}
        </Body>
        <FooterIntercomClickableHome isGooglebot={isGooglebot} />
      </Wrapper>
    )
  }
}

const OptimizedBuscaOffline = withSearchOptimizations(BuscaOffline)

OptimizedBuscaOffline.getInitialProps = wrapper.getInitialPageProps(
  store => async ({ isServer, query, asPath, ...args }) => {
    const path = asPath.split('?')[1] // eslint-disable-line
    const isGooglebot = query.isGooglebot || false
    const seoOffline = query.seoOffline
    let locationUrl = ''
    if (isServer) {
      locationUrl = args.req.headers.host
    }
    try {
      let LOCATIONS = JSON.parse(_LOCATIONS)
      let SYMPTOMS = JSON.parse(_SYMPTOMS)
      let SKILLS = JSON.parse(_SKILLS)
      const city = LOCATIONS.content.find(city => city.slug === query.city)
      const symptom = SYMPTOMS.results.find(s => s.slug === query.symptom)
      const symptoms = SYMPTOMS.results

      await store.dispatch({
        type: 'SYMPTOMS',
        payload: SYMPTOMS.results.reduce(
          (symptoms, symptom) => [...symptoms, ...symptom.symptoms],
          []
        )
      })
      await store.dispatch({
        type: 'SKILLS',
        payload: SKILLS.results.reduce((skills, skill) => [...skills, ...skill.skills], [])
      })

      await store.dispatch(resetFilters())

      const skill = SKILLS.results.find(s => s.slug === query.symptom)
      const neighborhood = query.neighborhood
        ? city.neighborhoods.find(n => n.slug_neighborhood === query.neighborhood)
        : null

      const {
        psychos: { next, prev }
      } = store.getState()
      await store.dispatch(
        updateFilter({
          startDate: moment().format('YYYY-MM-DD'),
          endDate: moment()
            .add(4, 'days')
            .format('YYYY-MM-DD'),
          lat: city ? (neighborhood ? neighborhood.latitude : city.latitude) : null,
          long: city ? (neighborhood ? neighborhood.longitude : city.longitude) : null,
          address: city ? (neighborhood ? neighborhood.neighborhood : city.name) : '',
          order: 'more_stars',
          seo_search: seoOffline,
          timezone: city ? city.timezone : ''
        })
      )
      await store.dispatch(loadPsychos(store.getState().filters, false))

      const params = {
        ...query,
        coupon: args.req ? args.req.query.coupon : null,
        lat: city ? (neighborhood ? neighborhood.latitude : city.latitude) : null,
        long: city ? (neighborhood ? neighborhood.longitude : city.longitude) : null,
        address: city ? (neighborhood ? neighborhood.neighborhood : city.name) : '',
        symptoms: symptom ? symptom.symptoms.map(s => s.title).join(',') : '',
        skills: skill ? skill.skills.map(s => s.id).join(',') : '',
        timezone: city ? city.timezone : '',
        order: args.req.query.order
      }

      const symptomsOptions = symptoms
        .map(symptom => {
          if (symptom?.symptoms[0] && symptom.symptoms[0]?.title) {
            return symptom?.symptoms[0]
          }
        })
        .filter(symptom => symptom)

      return {
        query: params,
        next,
        prev,
        locationUrl,
        isServer,
        isGooglebot,
        seoOffline,
        serverSideSymptoms: symptomsOptions,
        urlPath: getUrlFromReq(args.req)
      }
    } catch (error) {
      return { query, urlPath: getUrlFromReq(args.req) }
    }
  }
)

const Body = styled(Row)`
  display: block;
  margin-top: ${navHeight()};
  background: #eeeeee;
`

const mapStateToProps = globalState => ({
  psychologists: globalState.psychos,
  filters: globalState.filters,
  symptoms: globalState.symptoms,
  skills: globalState.skills
})

export default connect(mapStateToProps)(OptimizedBuscaOffline)
